var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarberPole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.855164,
    y: 15.0323,
    width: 11.2113,
    height: 1.43124,
    fill: "#FFC96A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.855164,
    y: 4.53662,
    width: 11.2113,
    height: 1.43123,
    fill: "#FFC96A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7545 4.29807H2.16711L3.47908 1.4356L6.9379 0.481445L10.1582 2.27049L10.7545 4.29807Z",
    fill: "#FFC96A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16711 16.9407L10.7545 16.9407L9.44255 19.8032L5.98373 20.7573L2.76346 18.9683L2.16711 16.9407Z",
    fill: "#FFC96A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26812 6.08716L2.16711 8.71109V6.08716H5.26812Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29572 14.7938L10.3967 12.1699L10.3967 14.7938L7.29572 14.7938Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32328 6.20642L2.28638 12.4084V14.9131H3.12126L10.8738 8.59181V6.20642H9.32328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 11.9314L10.6352 8.47253L3.47906 14.9131H7.05715L10.993 11.9314Z",
    fill: "#FF3E3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62592 6.20642L2.40564 8.71108V12.2892L6.4608 8.71108L8.72693 6.20642H5.62592Z",
    fill: "#59A5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7026 5.29992C12.7503 4.51274 12.1301 4.03566 11.3668 3.98795C11.0806 1.45944 8.67131 0.0759115 6.69143 0.00434977C4.52073 -0.0910659 1.8968 1.38788 1.61055 3.98795C0.799516 4.10722 0.298584 4.53659 0.298584 5.15679C0.298584 5.84856 0.751808 6.27793 1.61055 6.42105V14.5791C0.799516 14.6745 0.298584 15.1277 0.298584 15.7956C0.298584 16.4397 0.799516 16.9168 1.6344 17.0122C1.8968 19.3499 4.0675 20.8765 6.23821 20.9958C8.45662 21.1151 11.1044 19.66 11.4145 17.0122C12.2255 16.8929 12.7265 16.4635 12.7265 15.8433C12.7265 15.1516 12.2732 14.7222 11.4145 14.5791V6.42105C12.154 6.32564 12.6788 5.89627 12.7026 5.29992ZM2.75554 3.654C2.77939 3.58244 2.80324 3.51087 2.8271 3.41546C2.87481 3.24848 2.94637 3.10536 3.04178 2.93838C3.56657 1.93652 4.71156 0.958506 6.52445 0.958506C8.90985 0.958506 10.1502 2.67599 10.3172 3.89254H2.70783C2.73168 3.79712 2.73168 3.72556 2.75554 3.654ZM9.5539 18.7297C9.17224 19.1113 8.71901 19.4453 8.21808 19.66C7.71715 19.8985 7.19236 20.0178 6.66758 20.0416C4.49687 20.137 2.89866 18.6104 2.73168 17.1076H10.3172C10.3172 17.6324 10.0548 18.2049 9.5539 18.7297ZM11.6769 15.7956C11.6769 15.9388 11.5338 16.058 11.3429 16.0819C11.2952 16.0819 11.2475 16.0819 11.1998 16.0819H1.84909C1.30045 16.0819 1.30045 15.8911 1.30045 15.8195C1.30045 15.7479 1.3243 15.7002 1.37201 15.6525C1.44357 15.581 1.61055 15.5332 1.84909 15.5332H11.176C11.2237 15.5332 11.2714 15.5332 11.3429 15.5332C11.5338 15.5332 11.6769 15.6525 11.6769 15.7956ZM5.5703 6.54032H8.0034L2.66012 11.3588V9.16425L5.5703 6.54032ZM2.66012 7.82843V6.51647H4.09136L2.66012 7.82843ZM9.50619 6.54032H10.3411V7.82843L2.99408 14.4598H2.66012V12.6946L9.50619 6.54032ZM6.92997 14.4598H4.47302L10.3411 9.16425V11.3827L6.92997 14.4598ZM10.3411 12.7185V14.4598H8.40891L10.3411 12.7185ZM11.1521 5.49075H1.80138C1.75367 5.49075 1.72982 5.49075 1.68211 5.49075C1.46743 5.49075 1.30045 5.37148 1.3243 5.2045C1.3243 5.03752 1.46743 4.94211 1.68211 4.91826H11.1521C11.4145 4.91826 11.5576 4.96596 11.6292 5.03752C11.7008 5.08523 11.7008 5.15679 11.7008 5.2045C11.7008 5.27606 11.6769 5.32377 11.6292 5.37148C11.5338 5.44304 11.3668 5.49075 11.1521 5.49075Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarberPole);
export default __webpack_public_path__ + "static/media/barber_pole.a7e9aa2f2ff5c95a49383665848b5834.svg";
export { ForwardRef as ReactComponent };